'use strict';

var util = require('../util/property-util');
var userUtil = require('../util/user-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["$rootScope", "$http", "$q", "LoginService", "LogoutService", "$cookies", "RedirectService", "ProjectService", "ApiTokenManagement","$window", function AuthenticationFactory($rootScope, $http, $q, LoginService, LogoutService, $cookies, RedirectService, ProjectService, ApiTokenManagement, $window) {
    var currentUser;
    var userState;
    var loggingOut;
    var userStateDeferred = $q.defer();

    var factory = {};


    factory.hasAccess = function (pageName) {
        var user = factory.getUser();
        var pages = user.projectPageSet[ProjectService.getSelectedProjectId()];
        var hasAccess = false;
        if (util.isDefined(pages) && util.isDefined(pageName)) {
            hasAccess = pages.includes(pageName);
        }
        return hasAccess || user.admin;
    };

    factory.login = function (username, password) {
        var userPromise = LoginService.authenticate({username: username, password: password}).$promise;
        return userPromise.then(function (userResponse) {
            setUserDetails(userResponse, true);
            return userResponse;
        }, function (errorMsg) {
            return $q.reject(errorMsg);
        });
    };

    factory.authenticate = function (username, password) {
        return LoginService.authenticate({username: username, password: password}).$promise;
    };

    factory.userLogin = function (username, password) {
        var deferred = $q.defer();
        factory.authenticate(username, password).then(
            function (user) {
                if (user.firstlogin) {
                    deferred.resolve(user);
                } else {
                    setUserDetails(user, true);
                    deferred.resolve(user);
                }
            }
        ).catch(err => {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    //Change for NMS-206
    //Check if token has expired, true if expired/false if not
    factory.checkTokenExpiry = function(){
        var sessionLoginDetails = factory.getUserFromLocalStorage();
        if (sessionLoginDetails && sessionLoginDetails.token) {
            var expiryDate = Number(sessionLoginDetails.token.split(":")[1]);
            return expiryDate <= new Date().getTime();
        } else {
            return false;
        }
    };

    // todo: either rename function or create another for session storage
    factory.loginFromCookie = function () {
       
        if (factory.checkTokenExpiry()) {
            factory.logout();
            return undefined;
        } else {
            var sessionLoginDetails = factory.getUserFromLocalStorage();
            setUserDetails(sessionLoginDetails, false);
            return sessionLoginDetails;
        }
    };

    factory.getUserFromLocalStorage = function () {
        var sessionUserObject = localStorage.getItem("nomad.noc.ng.user");
        var token = ApiTokenManagement.getToken();

        if (util.isDefined(sessionUserObject)) {
            var sessionUser = JSON.parse(sessionUserObject)
            sessionUser.token = token;
            return sessionUser;
        } else {
            return null;
        }
    };

    factory.resetUserState = function () {
        userStateDeferred = $q.defer();
        userState = {
            'isLoggedIn': false,
            'isClient': false,
            'isAdmin': false,
            'isExpert': false,
            'isOperational': false,
            'isMonitoring': false,
            'isManager': false,
            'hasDashboard': false
        };
    };
    factory.getUser = function () {
        var token = ApiTokenManagement.getToken();
        if (currentUser) {
            currentUser.token = token;
        }
        return currentUser;
    };

    factory.isAdmin = function () {
        return currentUser && currentUser.admin;
    };

    factory.removeUserTrace = function () {
        factory.resetUserState();
        currentUser = undefined;

        delete $rootScope.user; //todo: remove this
        delete $http.defaults.headers.common['Auth-Token'];
        localStorage.removeItem("nomad.noc.ng.user");
        ApiTokenManagement.deleteToken();
        $cookies.remove("XSRF-TOKEN");
    };

    factory.getUserState = function () {
        return userState;
    };
    factory.getUserStatePromise = function () {
        return userStateDeferred.promise;
    };
    factory.isLoggingOut = function () {
        return loggingOut;
    };

    factory.logout = function (tokenExpired) {
        // the login pages used this boolean to prevent redirection to the home page (the user is still logged in at this point)
        loggingOut = true;
        RedirectService.gotoLoginPage(false);
        ProjectService.clearAll();
        if (tokenExpired) {
            RedirectService.resetRedirectPage();
            factory.removeUserTrace();
            loggingOut = false;
            $window.location.reload();
        } else {
            if (util.isDefined(currentUser)) {
                LogoutService.logout().get({id: currentUser.id}).$promise.then(function () {
                    // when explicitly pressing "logout" we don't want to remember the redirect page
                    RedirectService.resetRedirectPage();
                    factory.removeUserTrace();
                    loggingOut = false;
                    $window.location.reload();
                })
            }
        }
    };

    var setUserDetails = function (user, storeCookie) {
        if (util.isDefined(user)) {
            currentUser = user;
            var token = user.token;
            delete user.token;
            ProjectService.subscribe("USERSTATE", updateUserState);
            if (storeCookie) {
                localStorage.setItem("nomad.noc.ng.user", JSON.stringify(user));
                ApiTokenManagement.saveToken(token);
            }

            $rootScope.user = user; //todo: remove this
            $http.defaults.headers.common['Auth-Token'] = token;
        }
    };

    var updateUserState = function (projectId) {
        if (util.isDefined(currentUser)) {
            userState = {
                'isLoggedIn': util.isDefined(currentUser, projectId),
                'isAdmin': userUtil.isAdmin(currentUser, projectId)
            };
            userStateDeferred.resolve(userState);
        }
    };
    factory.resetUserState();
    return factory;
}];
